import PaneContainer from '@/layouts/components/PaneContainer'
import SingleColumn from '@/layouts/SingleColumn'
import { Card } from 'primereact/card'
import { Steps } from 'primereact/steps'
import Loader from './steps/Loader'
import Setting from './steps/Setting'
import CapacitySetting from './steps/CapacitySetting'
import Optimizer from './steps/Optimizer'
import { useCreatePlanFlow } from './hooks/useCreatePlanFlow'

function Dashboard() {
  const {
    stepIndex,
    steps,
    excelPlanResponse,
    optimizeRequest,
    optimizeMutation,
    goToStep,
    loadExcel,
    applySetting,
    applyCapacity,
    finalizeOptimization,
  } = useCreatePlanFlow()

  return (
    <SingleColumn>
      <PaneContainer>
        <div className="tm-grid tm-grid-cols-1 gap-4 w-full tw-mx-2 mx-auto">
          <h1 className="text-2xl font-medium mb-3">生産計画の作成</h1>
          <Card className="flex flex-column gap-4 w-full mx-auto">
            <Steps model={steps} activeIndex={stepIndex} className="mb-2" />
            { stepIndex === 0 && <Loader onLoad={loadExcel} /> }
            { stepIndex === 1 && <Setting response={excelPlanResponse} onSetting={applySetting} onBack={()=>goToStep(0)}/> }
            { stepIndex === 2 && optimizeMutation.data && optimizeRequest &&
               <CapacitySetting
               originalResponse={optimizeMutation.data}
               optimizeRequest={optimizeRequest}
               holidayDates={excelPlanResponse?.holidayDates}
               onBack={()=>goToStep(1)}
               onProceed={applyCapacity}
               />
            }
            { stepIndex === 3 && optimizeMutation.data && optimizeRequest &&
               <Optimizer
               originalResponse={optimizeMutation.data} optimizeRequest={optimizeRequest}
               onBack={()=>goToStep(2)}
               onProceed={finalizeOptimization}
               />
            }
          </Card>
        </div>
      </PaneContainer>
    </SingleColumn>
  )
}

export default Dashboard
